/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function LegislationAndRegulationInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Legislation Concerning Elections in Nova Scotia"
              description={
                <>
                  Elections in Nova Scotia are governed by provincial legislation. When delivering elections and related activities, we are responsible to obey and uphold all laws pertaining to elections in our province. <br /><br />
                  As an independent, non-partisan agency with a mandate is to conduct provincial general elections and by-elections, Elections Nova Scotia is primarily responsible for the administration of the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><em>Elections Act</em></a>.<br /><br />
                  <b>Elections Act Amendments</b><br/>
                  Amendments to the Elections Act to modernize the electoral process were tabled in the House of Assembly in Bill 205 on February 26, 2026. Bill 205 was passed on April 7, 2026, and received Royal Assent on April 9, 2026. The amendments to the Elections Act will come into effect on October 9, 2026, six months after Royal Assent.<br/>
                  Most of the amendments were recommended by the Chief Electoral Officer following the 2021 and 2024 provincial elections.<br/><br/>
                  Some of the changes to the legislation are as follows:<br/><br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>The removal of the requirement for candidates to pay a $200 nomination deposit.</li>
                    <li>Candidates may pay for publicity costs directly with their personal credit cards up to a maximum of $5,000.</li>
                    <li>The removal of the requirement for returning officers to reside in the electoral district in which they were appointed.</li>
                    <li>Clarification of the rules regarding the transfer of services, money, or property</li>
                    <li>The threshold requiring an audit of candidate’s election expense has increased from $500 to $1000.</li>
                    <li>During a writ period, candidates will only be registered through the nomination process. Outside of a writ period, candidate registration may occur at any time and is triggered when a candidate either receives or spends money.</li>
                    <li>Updated candidate and RO materials will be released on October 9, 2026.</li>
                  </ul>
                  <br/>
                  For more information on the Elections Act amendments in Bill 205, visit: <a href="https://nslegislature.ca/legislative-business/bills-statutes/bills/assembly-65-session-1/bill-205"><u>link</u></a>
                  <br/>
                  Form more information on the Chief Electoral Officer’s legislative recommendations, visit: <a href="https://www.electionsnovascotia.ca/files/GeneralElection_42nd/Volume2_Recommendations_September2025_FINAL.pdf"><u>link</u></a>
                  {/* Amendments to the Elections Act made by Chapter 8 of the Acts of 2020 were proclaimed in effect on May 6, 2021. Please click here for more details on these <a href="https://electionsnovascotia.ca/LegislativeAmendments"> legislative amendments</a>.<br /><br /> */}
                  <br/><br/>
                  <b>Other Legislation</b><br/>
                  Please see the menu below to access other legislation pertaining to elections and the political process in Nova Scotia:<br /><br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/income%20tax.pdf">Income Tax Act</a></li>
                    <li><a href="https://nslegislature.ca/sites/default/files/legc/statutes/controverted%20elections.pdf">Controverted Elections Act</a></li>
                    <li><a href="http://laws-lois.justice.gc.ca/eng/Const/index.html">Canadian Charter of Rights and Freedoms</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/freedom%20of%20information%20and%20protection%20of%20privacy.pdf">Freedom of Information and Protection of Privacy Act</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/human%20rights.pdf">Human Rights Act</a></li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default LegislationAndRegulationInformation;
